import axios from "axios";
import imageCompression from "browser-image-compression";

export const updateUserProfile = async (userInfo, belt, academy, address, image) => {
  const formData = new FormData();
  formData.append("email", userInfo[0].email);
  formData.append("smoothCompId", userInfo[0].smoothcompId);
  formData.append("belt", belt);
  formData.append("academy", academy);
  formData.append("address", address);

  if (image && image instanceof File) {
    try {
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };
      const compressedImage = await imageCompression(image, options);
      formData.append("image", compressedImage);
    } catch (error) {
      throw new Error("Error compressing image");
    }
  } else if (typeof image === "string") {
    formData.append("image", image);
  }

  try {
    await axios.post(`${process.env.REACT_APP_CONNECTION_API}/api/updateProfile`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return "Profile updated successfully!";
  } catch (error) {
    throw new Error("Error updating profile");
  }
};

export const getImageSrc = (imageData, defaultPath = '/path/to/default/avatar.png') => {
  if (!imageData) {
    return defaultPath;
  }

  if (typeof imageData === 'string' && imageData.length > 100) {
    if (!imageData.startsWith('[') && !imageData.startsWith('{')) {
      return `data:image/jpeg;base64,${imageData}`;
    }
  }

  let buffer = imageData;

  if (typeof imageData === 'object' && imageData !== null && imageData.type === 'Buffer' && Array.isArray(imageData.data)) {
    buffer = imageData.data;
  }

  if (typeof buffer === 'string') {
    try {
      const parsed = JSON.parse(buffer);
      if (parsed && parsed.type === 'Buffer' && Array.isArray(parsed.data)) {
        buffer = parsed.data;
      } else if (Array.isArray(parsed)) {
        buffer = parsed;
      } else {
        console.warn("Parsed image data is not a recognized buffer/array format:", parsed);
      }
    } catch (e) {
      // Ignore parsing errors
    }
  }


  if (buffer instanceof ArrayBuffer || Array.isArray(buffer) || (buffer && typeof buffer === 'object' && typeof buffer.length === 'number')) {
    try {
      let binary = '';
      const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      const base64String = btoa(binary);
      return `data:image/jpeg;base64,${base64String}`;
    } catch (error) {
      console.error("Error converting buffer/array to Base64:", error, buffer);
      return defaultPath;
    }
  }

  if (typeof buffer === 'string' && buffer.length > 100 && !buffer.startsWith('[') && !buffer.startsWith('{')) {
     return `data:image/jpeg;base64,${buffer}`;
  }


  //console.warn("Unrecognized image data format:", typeof imageData, imageData);
  return defaultPath;
};
export const getImageSrc2 = (imageData, defaultPath = '/path/to/default/avatar.png') => {
  // Handle null, undefined, empty string, AND the specific base64 encoded "null" string
  if (!imageData || imageData === "bnVsbA==") {
    return defaultPath; // Return default path for null/invalid cases
  }

  // 1. Check if it's already a Data URL (string starting with 'data:image')
  if (typeof imageData === 'string' && imageData.startsWith('data:image')) {
    return imageData;
  }

  // 2. Check if it's buffer data object { type: 'Buffer', data: [...] }
  if (typeof imageData === 'object' && imageData !== null && imageData.type === 'Buffer' && Array.isArray(imageData.data)) {
    // TODO: Determine the correct mimeType if possible (e.g., if backend sends it)
    const dataUrl = bufferToDataUrl(imageData, 'image/jpeg'); // Use the helper function
    return dataUrl || defaultPath; // Return dataUrl or default if conversion failed
  }

  // 3. Check if it's potentially a Base64 string (doesn't start with 'data:image')
  if (typeof imageData === 'string') {
    // Add a minimum length check to avoid misinterpreting short strings
    const minBase64Length = 20; // Adjust this threshold if needed
    // Basic check for Base64 characters. This is not foolproof but helps filter obvious non-base64.
    // Allows A-Z, a-z, 0-9, +, /, =
    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
    // Check length and pattern
    if (imageData.length >= minBase64Length && base64Regex.test(imageData)) {
       // TODO: Determine the correct mimeType if possible
       return `data:image/jpeg;base64,${imageData}`; // Assume JPEG
    }
  }

  // If none of the above checks passed, log a warning and return the default path
  //console.warn(`Unrecognized image data format encountered in getImageSrc. Type: ${typeof imageData}, Value snippet: ${String(imageData).substring(0, 50)}...`);
  return defaultPath;
};

export const bufferToDataUrl = (bufferData, mimeType = 'image/jpeg') => { // Default to JPEG, change if needed
  if (!bufferData || typeof bufferData !== 'object' || bufferData.type !== 'Buffer' || !Array.isArray(bufferData.data)) {
    console.warn("Invalid buffer data format received for conversion:", bufferData);
    return null;
  }
  try {
    const uint8Array = new Uint8Array(bufferData.data);
    // Use reduce for potentially better performance on large arrays vs String.fromCharCode.apply
    const binaryString = uint8Array.reduce((str, byte) => str + String.fromCharCode(byte), '');
    const base64String = btoa(binaryString);
    return `data:${mimeType};base64,${base64String}`;
  } catch (error) {
    console.error("Error converting buffer to Data URL:", error);
    return null;
  }
};